import * as Yup from 'yup';

export default Yup.object().shape({
  kraken_public_key: Yup.string().required('public key required'),
  kraken_private_key: Yup.string().required('private key required'),
  kraken_otp: Yup.string(),
});
